module.exports = __webpack_public_path__ + "static/media/icon_archive.8297371a.svg";